import { Form, Input, Button, Card, message } from 'antd';
import { forgotPasswordAPI } from '../api/auth.api';
import { useNavigate } from 'react-router-dom';

export default function ForgotPassword() {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = async (values: { email: string }) => {
    try {
      await forgotPasswordAPI(values.email);
      // Never leak whether the email exists.
      message.success('If the email exists, a reset link was sent.');
      setTimeout(() => navigate('/login'), 800);
    } catch (err) {
      const msg =
        (err as { response?: { data?: { error?: { message?: string } } } })?.response?.data?.error
          ?.message ?? 'Failed to request reset';
      message.error(msg);
    }
  };

  const redirectToLogin = (e: React.MouseEvent) => {
    e.preventDefault();
    const currentEmail = form.getFieldValue('email') || '';
   
    // navigate to forgot page
    window.location.href = '/login';
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f5f5f5',flexDirection: 'column' }}>
         <div>
        <img
          src="/images/logo.png"
          alt="Logo"
          style={{ height: 80, marginBottom: 24 }}
        />
      </div>
      <Card style={{ width: 420 }} title={<h3 style={{ margin: 0 }}>Forgot Password</h3>}>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item name="email" label="Email" rules={[{ required: true, message: 'Please enter your email' }, { type: 'email', message: 'Please enter a valid email' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block size="large">Send Reset Link</Button>
          </Form.Item>
        </Form>
        <div style={{textAlign:'right'}}><a href="#" onClick={redirectToLogin}>Sign In</a></div>
      </Card>
    </div>
  );
}
